RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.Admin = window.createMarionetteApp();
    app.name = 'Admin';

    app.addRegions({
        accountTab: '#tabUsers',
        editTab: '#tabEditing',
        queryTab: '#tabQueries'
    });

    app.on('start', function () {

        Backbone.history.start({
            // TODO move to pushState model
            //pushState: true,
            root: '/admin'
        });
    });
});
